import { memo, RefObject, useEffect, useRef } from "react";

import styles from "./styles.module.css";

type TableSimpleLoadMoreRowProps = {
  onLoadMore: () => void;
  columnsCount: number;
  rootMargin: string;
  scrollContainerRef: RefObject<HTMLDivElement | null>;
};

const TableSimpleLoadMoreRow = memo(
  ({ onLoadMore, columnsCount, rootMargin, scrollContainerRef }: TableSimpleLoadMoreRowProps) => {
    const sentinelRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
      const sentinel = sentinelRef.current;
      const scrollContainer = scrollContainerRef.current;

      if (!sentinel || !scrollContainer) {
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            onLoadMore();
          }
        },
        {
          root: scrollContainer,
          rootMargin,
        }
      );

      observer.observe(sentinel);

      return () => {
        observer.disconnect();
      };
    }, [onLoadMore, rootMargin, scrollContainerRef]);

    return (
      <div role="row" className={styles.loadMoreRow} aria-hidden="true">
        <div
          ref={sentinelRef}
          role="cell"
          className={styles.loadMoreCell}
          style={{ gridColumn: `span ${columnsCount}` }}
        />
      </div>
    );
  }
);

TableSimpleLoadMoreRow.displayName = "DS.TableSimple.LoadMoreRow";

export default TableSimpleLoadMoreRow;
